import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const PaymentButton = ({invoice, shipping ,amount, cart}) => {
    const [shippingAddress, setShippingAddress] = useState("");
    const navigate=useNavigate();

    useEffect(() => {
  if (!shipping) return;

  let formatted = '';

  if (shipping.id && shipping.contact) {
    // pickup point with contact
    formatted = `${shipping.name};${shipping.id};${shipping.contact.city};${shipping.contact.zip};${shipping.contact.phone}`;
  } else {
    // normal shipping address
    formatted = `${shipping.name};${shipping.address};${shipping.city};${shipping.zip};${shipping.phone}`;
  }

  setShippingAddress(formatted);
}, [shipping]);


    const handlePayment = async () => {
        if (invoice.payment=='bankcard') {
            try {
                const API = process.env.REACT_APP_BACKEND_URL;
                const order = await axios.post(`${API}/order`,{
                    name: invoice.name,
                    vat_number: invoice.tax,
                    company_name: invoice.company_name,
                    address:invoice.address,
                    postcode:invoice.zip,
                    city:invoice.city,
                    phone: invoice.phone,
                    email: invoice.email,
                    price: amount,
                    status: "pending",
                    cart: cart,
                    shipping: shippingAddress,
                    payment_type: invoice.payment
                })
                const orderId=order.data.order_id
                const response = await axios.post(`${API}/pay`, {
                    order_id: orderId,
                    total_amount: amount
                });
                
                // Redirect to Raiffeisen's Payment Page
                const { paymentUrl, paymentData } = response.data;
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = paymentUrl;
    
                Object.entries(paymentData).forEach(([key, value]) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = value;
                    form.appendChild(input);
                });
    
                document.body.appendChild(form);
                form.submit();
                
            } catch (error) {
                console.error('Payment error:', error);
            }
        } else {
            try {
                const API = process.env.REACT_APP_BACKEND_URL;
                const order = await axios.post(`${API}/order`,{
                    name: invoice.name,
                    vat_number: invoice.tax,
                    company_name: invoice.company_name,
                    address:invoice.address,
                    postcode:invoice.zip,
                    city:invoice.city,
                    phone: invoice.phone,
                    email: invoice.email,
                    price: amount,
                    status: "pending",
                    cart: cart,
                    shipping: shippingAddress,
                    payment_type: invoice.payment
                })
                const orderId=order.data.order_id
                navigate('/rendeles-visszaigazolas', {state: {orderId: orderId, method: invoice.payment, amount: amount}});
            } catch (error) {
                console.error('Payment error:', error);
            }
        }
        
    };

    return <button onClick={handlePayment}>Rendelés leadása és fizetés</button>;
}

export default PaymentButton